import moment from 'moment';
import { EventTypes } from 'redux-segment';

import CONF from 'config/conf.singleton';
import STORE from 'config/store.singleton';
import { AUTH_API } from 'middleware/api';
import { fromAnyDateToZuluDayBgn, fromAnyDateToZuluDayEnd } from 'utils/converters/time/from.util';

export const TRANSACTION_LOG_CSV_REQUEST = 'TRANSACTION_LOG_CSV_REQUEST';
export const TRANSACTION_LOG_CSV_SUCCESS = 'TRANSACTION_LOG_CSV_SUCCESS';
export const TRANSACTION_LOG_CSV_FAILURE = 'TRANSACTION_LOG_CSV_FAILURE';
export const BOOKING_LOG_CSV_REQUEST = 'BOOKING_LOG_CSV_REQUEST';
export const BOOKING_LOG_CSV_SUCCESS = 'BOOKING_LOG_CSV_SUCCESS';
export const BOOKING_LOG_CSV_FAILURE = 'BOOKING_LOG_CSV_FAILURE';
export const DELETED_BOOKING_LOG_CSV_REQUEST = 'DELETED_BOOKING_LOG_CSV_REQUEST';
export const DELETED_BOOKING_LOG_CSV_SUCCESS = 'DELETED_BOOKING_LOG_CSV_SUCCESS';
export const DELETED_BOOKING_LOG_CSV_FAILURE = 'DELETED_BOOKING_LOG_CSV_FAILURE';
export const APPOINTMENTS_REPORT_REQUEST = 'APPOINTMENTS_REPORT_REQUEST';
export const APPOINTMENTS_REPORT_SUCCESS = 'APPOINTMENTS_REPORT_SUCCESS';
export const APPOINTMENTS_REPORT_FAILURE = 'APPOINTMENTS_REPORT_FAILURE';
export const SALON_HOURS_REPORT_REQUEST = 'SALON_HOURS_REPORT_REQUEST';
export const SALON_HOURS_REPORT_SUCCESS = 'SALON_HOURS_REPORT_SUCCESS';
export const SALON_HOURS_REPORT_FAILURE = 'SALON_HOURS_REPORT_FAILURE';
export const SALES_REPORT_REQUEST = 'SALES_REPORT_REQUEST';
export const SALES_REPORT_SUCCESS = 'SALES_REPORT_SUCCESS';
export const SALES_REPORT_FAILURE = 'SALES_REPORT_FAILURE';
export const COMMISSION_REPORT_REQUEST = 'COMMISSION_REPORT_REQUEST';
export const COMMISSION_REPORT_SUCCESS = 'COMMISSION_REPORT_SUCCESS';
export const COMMISSION_REPORT_FAILURE = 'COMMISSION_REPORT_FAILURE';
export const REBOOKING_REPORT_REQUEST = 'REBOOKING_REPORT_REQUEST';
export const REBOOKING_REPORT_SUCCESS = 'REBOOKING_REPORT_SUCCESS';
export const REBOOKING_REPORT_FAILURE = 'REBOOKING_REPORT_FAILURE';
export const DAILY_REBOOKING_REPORT_REQUEST = 'DAILY_REBOOKING_REPORT_REQUEST';
export const DAILY_REBOOKING_REPORT_SUCCESS = 'DAILY_REBOOKING_REPORT_SUCCESS';
export const DAILY_REBOOKING_REPORT_FAILURE = 'DAILY_REBOOKING_REPORT_FAILURE';
export const CREATE_COMMISSION_RATE_REQUEST = 'CREATE_COMMISSION_RATE_REQUEST';
export const CREATE_COMMISSION_RATE_SUCCESS = 'CREATE_COMMISSION_RATE_SUCCESS';
export const CREATE_COMMISSION_RATE_FAILURE = 'CREATE_COMMISSION_RATE_FAILURE';
export const CHANGE_COMMISSION_RATE_REQUEST = 'CHANGE_COMMISSION_RATE_REQUEST';
export const CHANGE_COMMISSION_RATE_SUCCESS = 'CHANGE_COMMISSION_RATE_SUCCESS';
export const CHANGE_COMMISSION_RATE_FAILURE = 'CHANGE_COMMISSION_RATE_FAILURE';
export const FORECAST_REVENUE_REQUEST = 'FORECAST_REVENUE_REQUEST';
export const FORECAST_REVENUE_SUCCESS = 'FORECAST_REVENUE_SUCCESS';
export const FORECAST_REVENUE_FAILURE = 'FORECAST_REVENUE_FAILURE';
export const ACTUAL_SALES_DATA_REQUEST = 'ACTUAL_SALES_DATA_REQUEST';
export const ACTUAL_SALES_DATA_SUCCESS = 'ACTUAL_SALES_DATA_SUCCESS';
export const ACTUAL_SALES_DATA_FAILURE = 'ACTUAL_SALES_DATA_FAILURE';
export const GET_UNIQUE_CLIENTS_REQUEST = 'GET_UNIQUE_CLIENTS_REQUEST';
export const GET_UNIQUE_CLIENTS_SUCCESS = 'GET_UNIQUE_CLIENTS_SUCCESS';
export const GET_UNIQUE_CLIENTS_FAILURE = 'GET_UNIQUE_CLIENTS_FAILURE';
export const GET_UNIQUE_VISITS_REQUEST = 'GET_UNIQUE_VISITS_REQUEST';
export const GET_UNIQUE_VISITS_SUCCESS = 'GET_UNIQUE_VISITS_SUCCESS';
export const GET_UNIQUE_VISITS_FAILURE = 'GET_UNIQUE_VISITS_FAILURE';
export const GET_VISIT_FREQUENCY_REQUEST = 'GET_VISIT_FREQUENCY_REQUEST';
export const GET_VISIT_FREQUENCY_SUCCESS = 'GET_VISIT_FREQUENCY_SUCCESS';
export const GET_VISIT_FREQUENCY_FAILURE = 'GET_VISIT_FREQUENCY_FAILURE';
export const GET_GLOBAL_DISCOUNT_REQUEST = 'GET_GLOBAL_DISCOUNT_REQUEST';
export const GET_GLOBAL_DISCOUNT_SUCCESS = 'GET_GLOBAL_DISCOUNT_SUCCESS';
export const GET_GLOBAL_DISCOUNT_FAILURE = 'GET_GLOBAL_DISCOUNT_FAILURE';
export const SET_GLOBAL_DISCOUNT_REQUEST = 'SET_GLOBAL_DISCOUNT_REQUEST';
export const SET_GLOBAL_DISCOUNT_SUCCESS = 'SET_GLOBAL_DISCOUNT_SUCCESS';
export const SET_GLOBAL_DISCOUNT_FAILURE = 'SET_GLOBAL_DISCOUNT_FAILURE';
export const SET_DATE_PICKER_DATE = 'SET_DATE_PICKER_DATE';
export const CLEAR_ALL_ERROR_MESSAGES = 'CLEAR_ALL_ERROR_MESSAGES';
export const GET_STYLISTS_REQUESTS_REQUEST = 'GET_STYLISTS_REQUESTS_REQUEST';
export const GET_STYLISTS_REQUESTS_SUCCESS = 'GET_STYLISTS_REQUESTS_SUCCESS';
export const GET_STYLISTS_REQUESTS_FAILURE = 'GET_STYLISTS_REQUESTS_FAILURE';
export const SALES_DISCOUNTS_REPORT_REQUEST = 'SALES_DISCOUNTS_REPORT_REQUEST';
export const SALES_DISCOUNTS_REPORT_SUCCESS = 'SALES_DISCOUNTS_REPORT_SUCCESS';
export const SALES_DISCOUNTS_REPORT_FAILURE = 'SALES_DISCOUNTS_REPORT_FAILURE';
export const SET_SALON_VAT_RATE = 'SET_SALON_VAT_RATE';
export const SET_CURRENT_TABLE = 'SET_CURRENT_TABLE';
export const NEW_CLIENTS_REQUEST = 'NEW_CLIENTS_REQUEST';
export const NEW_CLIENTS_SUCCESS = 'NEW_CLIENTS_SUCCESS';
export const NEW_CLIENTS_FAILURE = 'NEW_CLIENTS_SUCCESS';
export const SET_STYLIST_ID_ORDER = 'SET_STYLIST_ID_ORDER';
export const GET_PRODUCT_SALES_REQUEST = 'GET_PRODUCT_SALES_REQUEST';
export const GET_PRODUCT_SALES_SUCCESS = 'GET_PRODUCT_SALES_SUCCESS';
export const GET_PRODUCT_SALES_FAILURE = 'GET_PRODUCT_SALES_FAILURE';
export const GET_PRODUCT_SALES_BY_STYLIST_REQUEST = 'GET_PRODUCT_SALES_BY_STYLIST_REQUEST';
export const GET_PRODUCT_SALES_BY_STYLIST_SUCCESS = 'GET_PRODUCT_SALES_BY_STYLIST_SUCCESS';
export const GET_PRODUCT_SALES_BY_STYLIST_FAILURE = 'GET_PRODUCT_SALES_BY_STYLIST_FAILURE';
export const STYLIST_PERFORMED_CATEGORIES_REQUEST = 'STYLIST_PERFORMED_CATEGORIES_REQUEST';
export const STYLIST_PERFORMED_CATEGORIES_SUCCESS = 'STYLIST_PERFORMED_CATEGORIES_SUCCESS';
export const STYLIST_PERFORMED_CATEGORIES_FAILURE = 'STYLIST_PERFORMED_CATEGORIES_FAILURE';
export const ALL_COMMISSION_REPORT_REQUEST = 'ALL_COMMISSION_REPORT_REQUEST';
export const ALL_COMMISSION_REPORT_SUCCESS = 'ALL_COMMISSION_REPORT_SUCCESS';
export const ALL_COMMISSION_REPORT_FAILURE = 'ALL_COMMISSION_REPORT_FAILURE';
export const GET_MONTHLY_REVENUE_REQUEST = 'GET_MONTHLY_REVENUE_REQUEST';
export const GET_MONTHLY_REVENUE_SUCCESS = 'GET_MONTHLY_REVENUE_SUCCESS';
export const GET_MONTHLY_REVENUE_FAILURE = 'GET_MONTHLY_REVENUE_FAILURE';
export const SET_MONTHLY_DATE_PICKER_DATE = 'SET_MONTHLY_DATE_PICKER_DATE';

export const deletedBookingLogCSV = (salonId, startDate, endDate) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/${salonId}/procedures/deleted/report/?start=${bgn}&end=${end}`,
      authenticated: true,
      types: [DELETED_BOOKING_LOG_CSV_REQUEST, DELETED_BOOKING_LOG_CSV_SUCCESS, DELETED_BOOKING_LOG_CSV_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'deletedBookingLog' },
    },
  };
};

export const transactionLogCSV = (salonId, startDate, endDate) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint: `checkout/cashup/${salonId}/transactionlog?start=${bgn}&end=${end}`,
      authenticated: true,
      types: [TRANSACTION_LOG_CSV_REQUEST, TRANSACTION_LOG_CSV_SUCCESS, TRANSACTION_LOG_CSV_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { startDate, endDate, key: 'transactionLog' },
    },
  };
};

export const bookingLogCSV = (salonId, startDate, endDate) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/${salonId}/procedures/report/?start=${bgn}&end=${end}`,
      authenticated: true,
      types: [BOOKING_LOG_CSV_REQUEST, BOOKING_LOG_CSV_SUCCESS, BOOKING_LOG_CSV_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'bookingLog' },
    },
  };
};

export const getAppointmentsReport = (salonId, startDate, endDate, mutateDates = true) => {
  const bgn = mutateDates ? fromAnyDateToZuluDayBgn(startDate) : startDate.toISOString();
  const end = mutateDates ? fromAnyDateToZuluDayEnd(endDate) : endDate.toISOString();
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/appointment/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [APPOINTMENTS_REPORT_REQUEST, APPOINTMENTS_REPORT_SUCCESS, APPOINTMENTS_REPORT_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'appointmentsReport' },
    },
  };
};

export const getSalonHoursReport = (salonId, startDate, endDate, mutateDates = true) => {
  const bgn = mutateDates ? fromAnyDateToZuluDayBgn(startDate) : startDate.toISOString();
  const end = mutateDates ? fromAnyDateToZuluDayEnd(endDate) : endDate.toISOString();

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/hours/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [SALON_HOURS_REPORT_REQUEST, SALON_HOURS_REPORT_SUCCESS, SALON_HOURS_REPORT_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { startDate, endDate, key: 'salonHoursReport' },
    },
  };
};

export const getRebookingReport = (salonId, startDate, endDate, mutateDates = true) => {
  const bgn = mutateDates ? fromAnyDateToZuluDayBgn(startDate) : startDate.toISOString();
  const end = mutateDates ? fromAnyDateToZuluDayEnd(endDate) : endDate.toISOString();
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/appointment/rebooking/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [REBOOKING_REPORT_REQUEST, REBOOKING_REPORT_SUCCESS, REBOOKING_REPORT_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'rebookingReport' },
    },
  };
};

export const getDailyRebookingReport = (salonId, startDate, endDate, mutateDates = true) => {
  const bgn = mutateDates ? fromAnyDateToZuluDayBgn(startDate) : startDate.toISOString();
  const end = mutateDates ? fromAnyDateToZuluDayEnd(endDate) : endDate.toISOString();
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/appointment/rebooking/${salonId}/${bgn}/${end}/daily/`,
      authenticated: true,
      types: [DAILY_REBOOKING_REPORT_REQUEST, DAILY_REBOOKING_REPORT_SUCCESS, DAILY_REBOOKING_REPORT_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { startDate, endDate, key: 'dailyRebookingReport' },
    },
  };
};

export const getSalesReport = (salonId, startDate, endDate, mutateDates = true, stylistList) => {
  const bgn = mutateDates ? fromAnyDateToZuluDayBgn(startDate) : moment(startDate).toISOString();
  const end = mutateDates ? fromAnyDateToZuluDayEnd(endDate) : moment(endDate).toISOString();
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/revenue/v2/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [SALES_REPORT_REQUEST, SALES_REPORT_SUCCESS, SALES_REPORT_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'salesReport', mutateDates, stylistList },
    },
  };
};

export const getNewClients = (salonId, startDate, endDate, stylistList) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/stylists/new_visits/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [NEW_CLIENTS_REQUEST, NEW_CLIENTS_SUCCESS, NEW_CLIENTS_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'newClientsReport', stylistList },
    },
  };
};

export function getCommissionReport(salonId, stylistId) {
  const endpoint = `salon/v2/${salonId}/stylist/${stylistId}/commissions/`;
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint,
      authenticated: true,
      types: [COMMISSION_REPORT_REQUEST, COMMISSION_REPORT_SUCCESS, COMMISSION_REPORT_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { stylistId, key: 'commissionReport' },
    },
  };
}

export function getAllCommissionReport(salonId) {
  const endpoint = `salon/v2/${salonId}/stylist/commissions/`;
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint,
      authenticated: true,
      types: [ALL_COMMISSION_REPORT_REQUEST, ALL_COMMISSION_REPORT_SUCCESS, ALL_COMMISSION_REPORT_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { key: 'allCommissionReport' },
    },
  };
}

export function createCommissionRate(salonId, stylistId, data) {
  const endpoint = `salon/v2/${salonId}/stylist/${stylistId}/commissions/`;
  data.stylist = stylistId;
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint,
      authenticated: true,
      types: [CREATE_COMMISSION_RATE_REQUEST, CREATE_COMMISSION_RATE_SUCCESS, CREATE_COMMISSION_RATE_FAILURE],
      config: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      },
      params: { stylistId, data },
    },
  };
}

export function changeCommissionRate(salonId, stylistId, data) {
  const endpoint = `salon/v2/${salonId}/stylist/${stylistId}/commissions/${data.id}/`;
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint,
      authenticated: true,
      types: [CHANGE_COMMISSION_RATE_REQUEST, CHANGE_COMMISSION_RATE_SUCCESS, CHANGE_COMMISSION_RATE_FAILURE],
      config: {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ percentage: data.percentage }),
      },
      params: { stylistId, data },
    },
  };
}

export function clearAllErrorMessages() {
  return {
    type: CLEAR_ALL_ERROR_MESSAGES,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export const setDatePickerDate = (fromDate, toDate) => ({
  type: SET_DATE_PICKER_DATE,
  fromDate,
  toDate,
  meta: { analytics: EventTypes.track },
});

export function setMonthlyDatePickerDate(fromDate, toDate, isFromDate) {
  return {
    type: SET_MONTHLY_DATE_PICKER_DATE,
    fromDate,
    toDate,
    isFromDate,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export const getForecastRevenue = (salonId, startDate, endDate) => {
  const start = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  const endpoint = `metrics/revenue/${salonId}/${start}/${end}/daily/`;
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint,
      authenticated: true,
      types: [FORECAST_REVENUE_REQUEST, FORECAST_REVENUE_SUCCESS, FORECAST_REVENUE_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { startDate, endDate, key: 'forecastRevenue' },
    },
  };
};

export const getActualSalesData = (salonId, startDate, endDate) => {
  const start = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  const endpoint = `checkout/metrics/transaction/${salonId}/${start}/${end}/daily/`;
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint,
      authenticated: true,
      types: [ACTUAL_SALES_DATA_REQUEST, ACTUAL_SALES_DATA_SUCCESS, ACTUAL_SALES_DATA_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { startDate, endDate, key: 'actualSalesData' },
    },
  };
};

export const getUniqueClients = (salonId, startDate, endDate) => {
  const start = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  const endpoint = `checkout/metrics/clients/retail/${salonId}/${start}/${end}/`;

  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint,
      authenticated: true,
      types: [GET_UNIQUE_CLIENTS_REQUEST, GET_UNIQUE_CLIENTS_SUCCESS, GET_UNIQUE_CLIENTS_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { startDate, endDate, key: 'uniqueClientsReport' },
    },
  };
};

export const getUniqueVisits = (salonId, startDate, endDate) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint: `checkout/metrics/visit/unique/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [GET_UNIQUE_VISITS_REQUEST, GET_UNIQUE_VISITS_SUCCESS, GET_UNIQUE_VISITS_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { startDate, endDate, key: 'uniqueVisitsReport' },
    },
  };
};

export const getVisitFrequency = (salonId, startDate, endDate) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint: `checkout/metrics/visit/frequency/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [GET_VISIT_FREQUENCY_REQUEST, GET_VISIT_FREQUENCY_SUCCESS, GET_VISIT_FREQUENCY_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { startDate, endDate, key: 'visitFrequencyReport' },
    },
  };
};

export function getGlobalDiscount(salonId) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/v2/${salonId}/commission/settings/`,
      authenticated: true,
      types: [GET_GLOBAL_DISCOUNT_REQUEST, GET_GLOBAL_DISCOUNT_SUCCESS, GET_GLOBAL_DISCOUNT_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function setGlobalDiscount(salonId, globalDiscount) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/v2/${salonId}/commission/settings/`,
      authenticated: true,
      types: [SET_GLOBAL_DISCOUNT_REQUEST, SET_GLOBAL_DISCOUNT_SUCCESS, SET_GLOBAL_DISCOUNT_FAILURE],
      config: {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ discount: globalDiscount.toFixed(8) }),
      },
      params: { globalDiscount },
    },
  };
}

export const getStylistsRequests = (salonId, startDate, endDate) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/stylists/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [GET_STYLISTS_REQUESTS_REQUEST, GET_STYLISTS_REQUESTS_SUCCESS, GET_STYLISTS_REQUESTS_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'stylistsRequestsReport' },
    },
  };
};

export const getProductSales = (salonId, startDate, endDate) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint: `checkout/metrics/product/retail/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [GET_PRODUCT_SALES_REQUEST, GET_PRODUCT_SALES_SUCCESS, GET_PRODUCT_SALES_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'productSalesReport' },
    },
  };
};

export const getProductSalesByStylist = (salonId, startDate, endDate) => {
  const start = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.transactionApiRoot,
      endpoint: `checkout/metrics/product/retail/bystylist/${salonId}/${start}/${end}/`,
      authenticated: true,
      types: [GET_PRODUCT_SALES_BY_STYLIST_REQUEST, GET_PRODUCT_SALES_BY_STYLIST_SUCCESS, GET_PRODUCT_SALES_BY_STYLIST_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'productSalesByStylistReport' },
    },
  };
};

export const getSalesDiscountsReport = (salonId, startDate, endDate, stylistList) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/discounts/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [SALES_DISCOUNTS_REPORT_REQUEST, SALES_DISCOUNTS_REPORT_SUCCESS, SALES_DISCOUNTS_REPORT_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
      params: { startDate, endDate, key: 'salesDiscountsReport', stylistList },
    },
  };
};

export const getStylistPerformedategories = (salonId, startDate, endDate) => {
  const bgn = fromAnyDateToZuluDayBgn(startDate);
  const end = fromAnyDateToZuluDayEnd(endDate);
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/stylists/categories/${salonId}/${bgn}/${end}/`,
      authenticated: true,
      types: [STYLIST_PERFORMED_CATEGORIES_REQUEST, STYLIST_PERFORMED_CATEGORIES_SUCCESS, STYLIST_PERFORMED_CATEGORIES_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'stylistPerformedCategoriesReport' },
    },
  };
};

export function setSalonVatRate(vat) {
  return {
    type: SET_SALON_VAT_RATE,
    vat,
  };
}

export function setStylistIDOrder(IDs) {
  return {
    type: SET_STYLIST_ID_ORDER,
    IDs,
  };
}

export function setCurrentTable(table) {
  return {
    type: SET_CURRENT_TABLE,
    table,
  };
}

export function getMonthlyRevenue(salonId, startDate, endDate) {
  let start = startDate;
  let end = endDate;

  if (startDate) {
    start = moment(startDate).startOf('day').toISOString();
  } else if (endDate) {
    start = moment(endDate).subtract(11, 'month').startOf('month').toISOString();
    STORE.dispatch(setMonthlyDatePickerDate(moment(start), moment(end), true));
  }

  if (endDate) {
    end = fromAnyDateToZuluDayEnd(endDate);
  }

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `metrics/revenue/v2/monthly/${salonId}/${start}/${end}/`,
      authenticated: true,
      types: [GET_MONTHLY_REVENUE_REQUEST, GET_MONTHLY_REVENUE_SUCCESS, GET_MONTHLY_REVENUE_FAILURE],
      config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
      params: { startDate, endDate, key: 'monthlyRevenueReport' },
    },
  };
}
